import { useEffect, useState, useCallback } from "react";
import { getCredits, reportEngagement } from "./api";

const EMAIL_KEY = "newseze.email";
const CODE_KEY = "newseze.ref_code";

export function getStoredEmail() {
  try { return localStorage.getItem(EMAIL_KEY) || ""; } catch { return ""; }
}
export function setStoredEmail(email, ref_code) {
  try {
    if (email) localStorage.setItem(EMAIL_KEY, email);
    if (ref_code) localStorage.setItem(CODE_KEY, ref_code);
  } catch {}
}
export function getStoredRefCode() {
  try { return localStorage.getItem(CODE_KEY) || ""; } catch { return ""; }
}

export default function useNewsezeUser() {
  const [email, setEmail] = useState(getStoredEmail());
  const [credits, setCredits] = useState(null);

  const refreshCredits = useCallback(async () => {
    if (!email) { setCredits(null); return; }
    try { setCredits(await getCredits(email)); } catch (e) { setCredits(null); }
  }, [email]);

  useEffect(() => { refreshCredits(); }, [refreshCredits]);

  const track = useCallback(async (kind, ref_id, duration_sec) => {
    if (!email) return null;
    try {
      const r = await reportEngagement({ email, kind, ref_id, duration_sec });
      refreshCredits();
      return r;
    } catch (e) { return null; }
  }, [email, refreshCredits]);

  return { email, setEmail: (e) => { setStoredEmail(e); setEmail(e); }, credits, refreshCredits, track };
}
